module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-3_EL-6069b703b463fb87b0a8d0dbf83e0c33.svg";